import paymentMethods from "@/helpers/paymentMethods"
import orderStatuses from "@/helpers/orderStatuses";

export default function() {
  return {
    paymentMethods,
    orderStatuses
  }
}
